import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { LobbyType } from '../../../features/workflow/types';

export const useGroupType = () => {
  const local = useLocation();
  return useMemo(() => {
    if (local.pathname.toLowerCase().includes('folio')) {
      return LobbyType.Folio;
    }
    if (local.pathname.toLowerCase().includes('email')) {
      return LobbyType.Inbox;
    }
  }, [local.pathname]);
};
